module.exports = __webpack_public_path__ + "static/media/4client.62882e05.png";